const WebPopupType = {
  SUBSCRIBE: 'subscribe',
  DOWNLOAD_APP: 'download_app',
  ALL_VIDEO: 'all_video'
};

export default WebPopupType;
